module.exports = __webpack_public_path__ + "media/images/seeds/johnb-a9bc907f83ec0901bae5d3328f053085.jpg";